import { Table, Tag } from "antd";
import { useActionDefaultDebugRefine } from "hook/base/debug/useActionDefaultDebug";
import React from "react";
import { getTime } from "util/time.function";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DebugTable = () => {
  // -------------------------- VAR -----------------------------
  const { data } = useActionDefaultDebugRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      title: "Tạo lúc",
      dataIndex: "createAt",
      key: "createAt",
      width: 200,
      render: (value) => renderTimer(value),
      sorter: (a, b) => a.createAt - b.createAt,
    },
    {
      title: "Tên Job",
      dataIndex: "document",
      key: "document",
      width: 200,

      render: (value) => <Tag>{value}</Tag>,
    },
    {
      title: "SL debug log",
      dataIndex: "remapping",
      key: "remapping",
      align: "center",
    },
    {
      title: "Kết quả",
      dataIndex: "result",
      key: "result",
      render: (_, record) => getResult(record),
    },
    {
      title: "status",
      dataIndex: "status",
      key: "status",
      render: (value) => <Tag>{value}</Tag>,
    },
  ];

  const renderTimer = (value) => {
    const label = getTime(value, "YYYY-MM-DD HH:mm:ss");
    return <span style={{ fontSize: 10 }}>{label}</span>;
  };

  const getResult = (record) => {
    const result = record?.result || {};
    const mapped = Object.entries(result)?.map(([key, value]) => {
      const title = OBJECT[key];
      return { title, value };
    });

    return (
      <div>
        {mapped?.map((item, index) => (
          <div key={index}>
            +<b className="mx-1">{item?.title}:</b>
            {item?.value}
          </div>
        ))}
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Table
      rowKey={"id"}
      bordered
      size="middle"
      columns={columns}
      dataSource={data}
      loading={data === null}
    />
  );
};
export default DebugTable;

const OBJECT = {
  guess: "Dự đoán",
  current: "Bước",
  currentTracker: "Đối chiếu",
  next: "Tiếp theo",
  nextTracker: "Đối chiếu tiếp theo",
  note: "Ghi chú",
};
